module.exports = __webpack_public_path__ + "img/yemen.590e790.webp";